<mat-card class="createCard">
    <mat-card-title class="text-center">
        @if (community?.registration_page_title_text_rendered) {
            <div [innerHTML]="community?.registration_page_title_text_rendered"></div>
        } @else {
            <h1 class="registerTitle">Join {{ companyName }}'s Community</h1>
        }
        @if (community?.registration_heading_help_text?.trim()) {
            <p class="registration-heading-help">{{ community?.registration_heading_help_text }}</p>
        }
    </mat-card-title>
    @if (!initialLoad) {
        <mat-card-content>
            <app-register [community]="community" [email]="email"></app-register>
        </mat-card-content>
    } @else {
        <mat-spinner color="accent"></mat-spinner>
    }

</mat-card>
